import { CONFIGURATION_PATH } from 'installations/navigation';

const indexComponent = require('./routes/index/components/InstallationConfiguration');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: CONFIGURATION_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/devices'),
        require('./routes/doors'),
        require('./routes/sources'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationConfiguration'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/index.js